import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ts-list-loading-indicator',
    imports: [CommonModule, TranslateModule],
    templateUrl: './list-loading-indicator.component.html',
    styleUrls: ['./list-loading-indicator.component.scss']
})
export class ListLoadingIndicatorComponent {}
